var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 22.333h1.467l3.733-10.8 4 10.8h1.6L16.733 9h-1.866L10.6 22.333zm11.867-3.6c.177 1.2.906 3.6 2.4 3.6h4c.71-.133 2.133-1.04 2.133-3.6v-7.2C30.822 10.69 29.987 9 28.067 9h-3.2c-.8.267-2.4 1.147-2.4 2.533v7.2zm1.466-6.933v6.8c.045.622.614 1.867 2.534 1.867 1.92 0 2.933-1.245 3.2-1.867v-6.8c-.356-.4-1.494-1.2-3.2-1.2-1.707 0-2.4.8-2.534 1.2zM1 9.267v13.066h5.467c.933-.177 2.8-.986 2.8-2.8V13c0-1.733-1.707-3.733-3.2-3.733H1zM2.6 20.2v-9.467h2.667c.8-.044 2.453.374 2.666 2.4.214 2.027.09 4.134 0 4.934-.177.71-.8 2.133-1.866 2.133H2.6z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/OM.960d8c09aec46bfe5d28350c7f2003c1.svg";
export { ForwardRef as ReactComponent };